export const prettifyHex = (hexStr: string) => {
  let res = ''
  for (let i = 0; i < hexStr.length; i += 2) {
    res += `${hexStr.substring(i, i + 2)} `
  }
  return res.trim().toUpperCase()
}

export const getNLengthHex = (l: number, n: number = 0): string => {
  if (l % 2 !== 0) {
    throw new Error('Invalid length for hex representation, must be even')
  }
  const s = n.toString(16).toUpperCase()
  const a: string[] = new Array<string>(l).fill('0')
  a.splice(a.length - s.length, s.length, ...s)
  return a.join('')
}
